import { Button, Card, Divider, Image, Typography } from "antd";
import { CourseRegistrationDTO } from "../../../interfaces/course-registration.interface";
import { getImage } from "../../../services/image-utils";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./course-registration.scss";
import { useNavigate } from "react-router-dom";
import { summ } from "../course-registration";
interface Props {
  data: CourseRegistrationDTO;
  summary: summ;
}

const CourseRegistrationSummary = ({ data, summary }: Props) => {
  const navigate = useNavigate();
  const handLogo = getImage("/assets/hand-orange.png");
  const { Text, Title, Paragraph, Link } = Typography;

  const reedirect = (swi: boolean) => {
    navigate(`/SEABC/${swi ? "my-courses" : "courses"}`);
  };

  return (
    <div className="flex justify-center p-10 registration-registration-step">
      <Card className="max-w-3xl" hoverable={true}>
        <div className="flex flex-col items-center">
          <Image width={50} preview={false} src={handLogo} />
          <Title level={2} style={{ fontWeight: "400" }}>
            Thank you, {data.firstName}!
          </Title>
          <Divider></Divider>
          <Paragraph className="text-center max-w-96">
            {summary.payMethod === "Cheque" ? (
              <>
                {" "}
                <Text strong>Your registration is pending </Text>
                until your cheque is received, we will send you an email to
                confirm your registration.
              </>
            ) : summary.payMethod === "Paypal" ? (
              <Text strong>Your are now registered for this course! </Text>
            ) : (
              <>
                <div>
                  <Text strong>Your have been added to the waitlist</Text>
                </div>
                <Text>
                  We will send you an email to let you know if a spot becomes
                  available.
                </Text>
              </>
            )}
          </Paragraph>
          <>
            {summary.payMethod === "Cheque" ? (
              <div className="flex items-start text-center gap-1 max-w-96">
                <ExclamationCircleOutlined style={{ fontSize: "1.2rem" }} />
                <Paragraph>
                  <Text strong>Please Note: </Text>
                  The confirmation email may experience a short delay. Make sure
                  to check your "spam" folder.
                </Paragraph>
              </div>
            ) : summary.payMethod === "Paypal" ? (
              <Text>
                {data?.course?.code} - {data?.course?.registrationType}
              </Text>
            ) : (
              <></>
            )}
          </>
          {summary.payMethod === "Cheque" && (
            <>
              <Title level={3}>Next steps:</Title>
              <div className="flex flex-col gap-2">
                <div className="flex gap-2 items-baseline">
                  <div className="custom-circle">1</div>
                  <Paragraph style={{ margin: 0 }}>
                    Click the link to
                    <Link target="_blank" href={summary.link}>
                      {" "}
                      Download my Invoice{" "}
                    </Link>
                    <Text italic>(It will also be emailed to you)</Text>
                  </Paragraph>
                </div>
                <div className="flex gap-2 items-baseline">
                  <div className="custom-circle">2</div>
                  <Text>Print & attach it to your cheque</Text>
                </div>
                <div className="flex gap-2 items-baseline">
                  <div className="custom-circle">3</div>
                  <Text>
                    Send the Invoice and the Cheque to the address prescribed
                  </Text>
                </div>
              </div>
            </>
          )}
          <Divider></Divider>
          {(summary.payMethod === "Cheque" ||
            summary.payMethod === "Paypal") && (
            <Paragraph>
              This course has been added to <Text strong>"My Courses"</Text> in
              your account
            </Paragraph>
          )}
          {summary.payMethod !== "Cheque" && (
            <div className="flex items-start text-center gap-1 max-w-96">
              <ExclamationCircleOutlined style={{ fontSize: "1.2rem" }} />
              <Paragraph>
                <Text strong>Please Note: </Text>
                {summary.payMethod === "Paypal"
                  ? 'Paypal may take up to 1 hour to process. Please check your "spam" folder for email confirmations.'
                  : 'The email may experience a short delay. Make sure to check your "spam" folder.'}
              </Paragraph>
            </div>
          )}
          <div className="flex gap-5">
            <Button
              style={{ height: "2.3rem" }}
              type="primary"
              onClick={() => reedirect(true)}
            >
              My Courses
            </Button>
            <Button
              style={{ height: "2.3rem" }}
              onClick={() => reedirect(false)}
            >
              All Courses
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CourseRegistrationSummary;
